module.exports = __webpack_public_path__ + "img/xuanchuan.c5508bad.png";